import {Auth} from 'aws-amplify'
import axios from 'axios'

export default {
  mounted() {},
  methods: {
    // summary: Download the data of brain
    async downloadBrainDetail(brainId, what) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/downloads/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              what: what,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: "Returns the total number and a partial list of brains owned by the user"
    async getBrains(type = 'default', shared = false) {
      let items = []
      const LIMIT = 500
      const params = {
        limit: LIMIT,
      }
      if (type === 'archives') {
        params.archived = true
      }
      if (type === 'share') {
        params.shared = true
      }
      if (type === 'public') {
        params.public = true
      }
      const path = shared ? '/mybrains?shared=true' : '/mybrains'

      try {
        let offset = 0
        while (true) {
          params.offset = offset
          const brains = await axios.get(
            process.env.VUE_APP_API_ENDPOINT + path,
            {
              headers: {
                Authorization: (await Auth.currentSession()).getIdToken()
                  .jwtToken,
              },
              params: params,
            }
          )
          items = items.concat(brains.data.Items)
          if (brains.data.Items.length >= LIMIT) {
            offset += LIMIT
          } else {
            break
          }
        }
        return items
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Returns a brain item by ID
    async getBrainById(brainId) {
      try {
        const brain = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return brain.data
      } catch (error) {
        // This error is handled by parent function.
        throw error
      }
    },
    async getBrainPermission(brainId) {
      try {
        const brain = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/permission/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return brain.data
      } catch (error) {
        // This error is handled by parent function.
        throw error
      }
    },
    // summary: Returns a thumbnail image (PNG format) by ID
    async getBrainThumbnailById(brainId) {
      try {
        const thumbnail = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/thumbnail/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return `data:${thumbnail.headers[
          'content-type'
        ].toLowerCase()};base64,${thumbnail.data}`
      } catch (error) {
        // Do nothing because this error isn't critical.
        return false
      }
    },
    // summary: Post a thumbnail image (JPG/PNG format) by ID
    async setBrainThumbnailById(brainId, file) {
      try {
        const image = await this.getBase64(file)
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/thumbnail/' + brainId,
          {
            // Parameter "Format" is for future use. Do not use at the moment.
            // Format: "png",
            Data: image,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Update property about the brain
    async setBrainAttribute(brainId, attributeName, attributeValue) {
      try {
        const result = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/' + brainId,
          {
            [attributeName]: attributeValue,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Returns a list of tags in specified category
    async getMyTags(category) {
      try {
        const tags = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mytags',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              category: category,
            },
          }
        )
        return tags.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getMyTagsById(category, itemId) {
      try {
        const tags = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mytags/' + itemId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              category: category,
            },
          }
        )
        return tags.data
      } catch (error) {
        // Not alerted. The errors of this api is ignored.
        // alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Get users who share the brain.
    async getSharedOfBrain(brainId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/share/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Share the brain.
    async postShareOfBrain(brainId, param) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/share/' + brainId,
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        // This error is handled by parent function.
        throw error
      }
    },
    // summary: Make the brain unshared for the specified user.
    async deleteShareOfBrain(brainId, email) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/share/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              email: email,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async registerBrain(newBrain) {
      try {
        const param = {}
        if (newBrain.title.value) {
          param['Title'] = newBrain.title.value
        }
        if (newBrain.strain.value) {
          param['Strain'] = newBrain.strain.value
        }
        if (newBrain.age.value) {
          param['Age'] = newBrain.age.value
        }
        if (newBrain.cellLabels.value) {
          param['CellLabels'] = newBrain.cellLabels.value
        }
        if (newBrain.experimentLabels.value) {
          param['ExperimentLabels'] = newBrain.experimentLabels.value
        }
        if (newBrain.notes.value) {
          param['Notes'] = newBrain.notes.value
        }
        param['RegistrationParameters'] = newBrain.registrationParameters
        param['TableFormat'] = newBrain.tableFormat
        if (
          newBrain.tablePixelSizeX.value &&
          newBrain.tablePixelSizeY.value &&
          newBrain.tablePixelSizeZ.value
        ) {
          param['TablePixelSize'] = {
            X: newBrain.tablePixelSizeX.value,
            Y: newBrain.tablePixelSizeY.value,
            Z: newBrain.tablePixelSizeZ.value,
          }
        }
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains',
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },

    // summary: Upload file for brain
    async uploadFile(data, file, url, config) {
      // ref: https://gist.github.com/virolea/e1af9359fe071f24de3da3500ff0f429
      const formData = new FormData()
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key])
        }
      }
      formData.append('file', file)
      try {
        await axios.post(url, formData, config)
      } catch (error) {
        throw error
      }
    },

    // summary: Add a new tag
    async addMyTags(category, data) {
      try {
        const tags = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + `/mytags?category=${category}`,
          data,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return tags.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Updates a tag by its item ID
    async editMyTags(category, data, itemId) {
      try {
        const tag = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT + `/mytags/${itemId}`,
          data,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              category: category,
            },
          }
        )
        return tag.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Delete a tag by its item ID
    async deleteMyTags(category, itemId) {
      try {
        const tag = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + `/mytags/${itemId}`,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              category: category,
            },
          }
        )
        return tag.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Delete the brain.
    async deleteBrain(itemId, destroy = false) {
      const params = {}
      if (destroy) {
        params['destroy'] = true
      }
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + `/mybrains/${itemId}`,
          {
            params: params,
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Restore the brain.
    async restoreBrain(itemId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
            `/mybrains/archives/restore/${itemId}`,
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Publish the brain.
    async postPublishOfBrainV2(itemId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + `/mybrains/public/${itemId}`,
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async importBrainById(brainId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/mybrains/import/' + brainId,
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        alert(
          'Import job has been submitted to the server. This process may take several minutes'
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Get viewer.
    async brainsViewer(brainId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/viewer/' + brainId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        // Parent function handles this error.
        throw error
      }
    },
  },
}
